module.exports = __webpack_public_path__ + "static/original-sm-753975fea5412054a7701fa9fc558234.jpg";